export default "__VITE_ASSET__o42GM2mC__"